import React from "react";
import { Box, Placeholder, Stack } from "@origin-digital/ods-core";
import { ResponsiveSpace } from "@origin-digital/ods-types";
import { DetailProps } from "./types";
import { useResponsiveBelowLg } from "src/hooks";
import { SidebarOuterBox } from "./SiderbarOuterBox";
import { DefaultPageTitleSection } from "./DefaultPageTitleSection";
import { DefaultAddressSection } from "./DefaultAddressSection";

export const Detail = ({
  pageTitleSection = <Placeholder label="Page title" height="28px" />,
  addressSection,
  sidebarSection = (
    <Placeholder label="Sidebar navigation" width={240} height={320} />
  ),
  children: contentSection = (
    <Placeholder label="Form <AccordionGroup> / <Card>" height="2000px" />
  ),
  "data-id": dataId = "detail",
  alertBannerSection,
  snackbarSection,
}: DetailProps) => {
  const isBelowLg = useResponsiveBelowLg();
  return (
    <Box
      // These hardcoded values may throw TS errors - for demo purposes only.
      // Solution to be left up the the developer
      marginTop={
        {
          xs: "32px",
          lg: "56px",
        } as unknown as ResponsiveSpace
      }
      marginX={"auto" as unknown as ResponsiveSpace}
      paddingX={["medium", "large"]}
      style={{ maxWidth: "1440px", zIndex: "20", top: "0" }}
      width="full"
      data-id={`${dataId}.rootContainer`}
    >
      {alertBannerSection}

      {/* Inner container */}
      <Stack space={["large", "xlarge"]}>
        {/* Page title + Actions */}
        <Box display="flex" flexDirection="column" gap={["medium", "large"]}>
          {/* Page title */}
          {pageTitleSection && (
            <Box data-id={`${dataId}.pageTitleSection`}>
              <DefaultPageTitleSection>
                {pageTitleSection}
              </DefaultPageTitleSection>
            </Box>
          )}
          {/* Address only shown once premise is created and only at XS > MD */}
          {isBelowLg && addressSection && (
            <Box data-id={`${dataId}.addressSection`}>
              <DefaultAddressSection>{addressSection}</DefaultAddressSection>
            </Box>
          )}
          {/* End Page title */}
        </Box>
        {/* End Page title + Actions */}
        {/* Form */}
        <Box
          display="flex"
          gap="xlarge"
          marginBottom="xlarge"
          data-id={`${dataId}.innerContainer`}
        >
          {!isBelowLg && sidebarSection && (
            <Box display="block">
              <Box
                data-id={`${dataId}.sidebarSection`}
                style={{
                  position: "sticky",
                  top: 96,
                }}
              >
                <SidebarOuterBox>{sidebarSection}</SidebarOuterBox>
              </Box>
            </Box>
          )}
          {/* Form */}
          <Box
            justifyContent="center"
            alignItems="center"
            style={{
              width: "100%",
            }}
            data-id={`${dataId}.contentSection`}
            data-role="section"
          >
            {contentSection}
          </Box>
          {/* End form */}
        </Box>
        {/* Form */}
      </Stack>
      {/* End Inner container */}
      {snackbarSection}
    </Box>
  );
};
